<!-- Security - Demo Provider-->

<!-- users table -->
<hr>
<div>
    <form name="demoForm">
        <div>
            <div class="demo_newUser">
                <table class="wm-table add-row-form no-border">
                    <tbody>
                        <tr class="no-border">
                            <td class="pl-0"><h5>New User</h5></td>
                            <td class="username no-border" [ngClass]="{'error':error.uError}">
                                <input name="wm-security-username" placeholder="{{locale.LABEL_ENTER_USERNAME}}" type="text" class="form-control app-textbox" [(ngModel)]="security.demoUsername" (click)="error.uError = false;"/>
                        </td>
                            <td class="password no-border" [ngClass]="{'error':error.pError}">
                                <input name="wm-security-userpassword" placeholder="{{locale.LABEL_ENTER_PASSWORD}}"  type="text" class="form-control app-textbox" [(ngModel)]="security.demoUserPassword"  (click)="error.pError = false;"/>
                            </td>
                            <td class="no-border" [ngClass]="{'error':error.rError}">
                                <div class="wms-typeahead-security-page">
                                    <wms-typeahead name="wm-security-userrole" placeholder="{{locale.LABEL_SEARCH_USER_ROLE}}" [model]="security.demoUserRole" [options]="security.roles" (onSelect)="handleModelChange($event); error.rError = false;"> </wms-typeahead>
                                </div>
                            </td>
                            <td>
                                <button name="wm-addvariable-save" (click)="addDemoUser()" class="btn app-button button-primary"><span class="btn-caption">{{locale.LABEL_ADD_DEMO_USER}}</span></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
               
            </div>
            <table class="wm-table mt-10">
                <colgroup>
                    <col width="200">
                    <col width="200">
                    <col width="200">
                </colgroup>
                <thead>
                <tr>
                    <th>{{locale.LABEL_USERNAME}}</th>
                    <th>{{locale.LABEL_PASSWORD}}</th>
                    <th>{{locale.LABEL_APP_ROLE}}</th>
                </tr>
                </thead>
            </table>
            <div class="list-table scroll-content">
                <table class="wm-table">
                    <colgroup>
                        <col width="240">
                        <col width="240">
                        <col width="240">
                    </colgroup>
                    <tbody>
                        <tr  *ngFor="let user of security.demoUsers; let $index=index">
                            <td>
                                <span class="title" title="{{user.username}}">{{user.username}}</span>
                            </td>
                            <td>
                                <span class="title" title="{{user.password}}">{{user.password}}</span>
                            </td>
                            <td class="wm-role-selector-row">
                                <wms-role-selector class="app-accessroles-select multiSelect_menu" [roles]="sortedRolesList"
                                (onChange)="onRoleChange($event, user); updateDirtyCheckList();"
                                [mode]="'dropdown'"
                                [model]="user.roles" [isProperty]="true"></wms-role-selector>
                                <button (click)="removeDemoUser(user.username)" class="btn btn-transparent pull-right app-button" name="wm-security-remove-user{{$index}}" *ngIf="!user.isDefault">
                                    <i class="wm-icon wms wms-delete"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>
</div>

